import { ReactComponentManifest } from "web/entrypoints/common/setup";
import { CuratedCollection } from "web/react/pages/curated-collection";
import withRedux from "web/react/redux-provider";

export const curatedCollectionComponents: ReactComponentManifest = {
    CuratedCollection: withRedux(CuratedCollection),
};
